<template>
  <transition name="fade">
    <div v-show="visible" class="insect-mng">
      <div class="insect-mng-head">
        <div class="insect-mng-subtitle">
          <slot name="subtitle">{{ subtitle }}</slot>
        </div>

        <div class="insect-mng-title">
          <slot name="title">{{ title || '图片管理器' }}</slot>
        </div>

        <div class="insect-mng-control">
          <!-- <el-tooltip effect="dark" placement="bottom">
            <span slot="content">
              激活后在图片上画框可以显示尺<br />
              快捷键：Shift
            </span>
            <el-button :class="{ actived: drawing }" @click="setDrawing">
              {{ drawing ? '测量中' : '测量尺寸' }}
            </el-button>
          </el-tooltip> -->

          <el-button
            plain
            slot="tools"
            :disabled="!(insects && insects.length)"
            @click="switchRecognize"
          >
            {{ showInsects ? '关闭识别' : '显示识别' }}
          </el-button>

          <el-button-group slot="tools" style="margin-left: 1rem;">
            <el-button plain @click="download">
              原图下载
            </el-button>
            <el-button plain @click="downloadCanvas">
              标注下载
            </el-button>
          </el-button-group>

          <i class="el-icon-close" @click="close"></i>
        </div>
      </div>

      <div class="insect-mng-content" ref="wrap">
        <el-tooltip
          v-if="next >= 0 && next !== null"
          effect="dark"
          placement="bottom"
        >
          <span slot="content">
            快捷键：&lt;-
          </span>

          <el-button
            class="modal-button prev"
            icon="el-icon-arrow-left"
            circle
            :disabled="loading"
            @click="go(next)"
          >
          </el-button>
        </el-tooltip>

        <el-tooltip v-if="prev > 0" effect="dark" placement="bottom">
          <span slot="content">
            快捷键 ->
          </span>

          <el-button
            class="modal-button next"
            icon="el-icon-arrow-right"
            circle
            :disabled="loading"
            @click="go(prev)"
          >
          </el-button>
        </el-tooltip>

        <div v-if="loading" class="modal-button">
          <i class="el-icon-loading"></i>
        </div>

        <div
          class="tools"
          :style="{ left: `calc((100% - ${cw}px) / 2 - 48px)` }"
        >
          <el-tooltip effect="dark" placement="left">
            <span slot="content">
              矩形测量工具<br />
              快捷键：Shift
            </span>
            <el-button
              icon="el-icon-full-screen"
              circle
              :class="{ actived: drawing }"
              @click="setDrawing"
            ></el-button>
          </el-tooltip>

          <el-tooltip effect="dark" placement="left">
            <span slot="content">
              线条测量工具<br />
              <!-- 快捷键：Alt -->
            </span>
            <el-button
              circle
              :class="{ actived: drawingLine }"
              @click="setDrawingLine"
            >
              <svg-icon iconClass="line"></svg-icon>
            </el-button>
          </el-tooltip>
        </div>

        <div
          v-show="!loading"
          class="wrap2"
          ref="wrap2"
          :style="{
            width: `${cw}px`,
            height: `${ch}px`
          }"
          :class="{ drawing: drawing || drawingLine }"
        >
          <div class="coner" style="width: 15px;height: 15px;"></div>

          <ruler-h
            :width="cw - ctrlSpace"
            :height="ctrlSpace"
            :length="rulerHeight"
            :scale-width="iw * layout.scale"
            :move="rulerHMove"
          ></ruler-h>

          <ruler-v
            :width="ctrlSpace"
            :height="ch - ctrlSpace"
            :length="rulerWidth"
            :scale-height="ih * layout.scale"
            :move="rulerVMove"
          ></ruler-v>

          <div v-if="drawing" class="scale-rect" :style="rectStyle">
            <div class="rect-size">
              {{ px2mm(iw * layout.scale, rect[2], rulerHeight * 10) }}mm X
              {{ px2mm(ih * layout.scale, rect[3], rulerWidth * 10) }}mm
            </div>
          </div>

          <div v-if="drawingLine" class="scale-line" :style="lineStyle">
            <div class="line-size">
              {{
                px2mm(
                  iw * layout.scale,
                  Math.sqrt(rect[2] * rect[2] + rect[3] * rect[3]),
                  297
                )
              }}mm
            </div>
          </div>

          <div
            :style="{
              transform: `rotate(${rotate}deg)`,
              ['transform-origin']: 'center center'
            }"
          >
            <div
              v-show="!loading"
              class="insect-mng-container"
              ref="test"
              :style="{ transform }"
            >
              <div>
                <canvas
                  id="img"
                  ref="img"
                  @mousedown="startMove"
                  @dblclick="dbZoom"
                ></canvas>

                <div v-show="showInsects" class="insects-rect">
                  <div
                    class="model-insect"
                    v-for="(item, index) in insects"
                    :key="item.id"
                    :class="{
                      [`category-${item.categoryId}`]: true,
                      actived: index === actived
                    }"
                    :style="
                      insectStyle(
                        item,
                        rotate === 90 ? ih : iw,
                        rotate === 90 ? iw : ih
                      )
                    "
                  >
                    <div
                      class="model-insect__name"
                      :class="{ rotate: rotate === 90 }"
                    >
                      {{ item.category }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="insects-tb"
          :style="{
            right: `calc((100% - ${cw}px) / 2 - 140px)`,
            ['max-height']: `${ch}px`
          }"
        >
          <div
            class="insects-tb-row"
            v-for="(ins, index) in insects"
            :key="ins.id"
            :class="{ actived: index === actived }"
            @click="focus(index)"
          >
            <span class="insects-tb-row__num">{{ index + 1 }}</span>
            <span>{{ ins.category }}</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const CTRL_SPACE = 30 // 标尺宽度
const COE = 1 // 缩放系数

import RulerH from './components/rulerH'
import RulerV from './components/rulerV'

import path from 'path'
// import _ from 'lodash'
import downloadLamp from '@/components/Download'

export default {
  components: { RulerH, RulerV },
  props: {
    id: [Number, String],
    title: String,
    subtitle: String,
    src: String,
    insects: Array,
    prev: Number,
    next: Number
  },
  data() {
    return {
      visible: true,
      loading: true,
      showInsects: true, // 现实识别
      support: 'onwheel',
      actived: -1,
      initScale: 1, // 最小放大倍数，初始
      maxZoom: 1.2, // 最大放大倍数
      rotate: 0,
      scale: 1,
      move: [0, 0],
      prevMove: [0, 0], // 上次移动
      downPoint: [0, 0], // 点击处
      cw: 1024, // 图片容器 宽
      ch: 768, // 图片容器 高
      iw: 1024, // 图片宽
      ih: 768, // 图片高
      ctrlSpace: CTRL_SPACE,
      drawing: false, // 画矩形框，测量实际尺寸
      drawingLine: false, // 画线，测量尺寸
      rect: [0, 0, 0, 0], // 测量矩形 [x, y, w, h]
      layout: { scale: 1, move: [0, 0], prevMove: [0, 0] }
    }
  },
  computed: {
    isIE() {
      //取得浏览器的userAgent字符串
      const userAgent = navigator.userAgent
      //判断是否IE浏览器
      return (
        userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
      )
    },
    transform() {
      const { scale, move } = this.layout
      return `translate(${move[0]}px, ${move[1]}px) scale(${scale},${scale})`
    },
    rectStyle() {
      const [x, y, w, h] = this.rect
      return {
        transform: `translate(${x}px, ${y}px)`,
        width: `${Math.abs(w)}px`,
        height: `${Math.abs(h)}px`
      }
    },
    lineStyle() {
      // + (w < 0 ? 180 : 0)
      const [x, y, w, h] = this.rect
      const width = Math.ceil(Math.sqrt(w * w + h * h))
      const offsetX = w < 0 ? width + w + 1 : 0
      const offsetY = h < 0 ? h : 0
      const tx = x - offsetX
      const ty = y - offsetY - 1
      const rotate = (Math.atan(h / w) / Math.PI) * 180
      return {
        width: `${width}px`,
        transform: `translate(${tx}px, ${ty}px) rotate(${rotate}deg)`,
        ['transform-origin']: w < 0 ? `right top` : 'left top'
      }
    },
    rulerHeight() {
      return this.rotate === 90 ? 29.7 : 21.2
    },
    rulerWidth() {
      return this.rotate === 90 ? 21.6 : 16.2
    },
    sin() {
      return Math.sin((-this.rotate / 180) * Math.PI)
    },
    cos() {
      return Math.cos((-this.rotate / 180) * Math.PI)
    },
    nowCentX() {
      return (
        Math.floor(
          (((this.layout.scale - this.initScale) * this.iw) / 2) * 100
        ) / 100
      )
    },
    nowCentY() {
      return (
        Math.floor(
          (((this.layout.scale - this.initScale) * this.ih) / 2) * 100
        ) / 100
      )
    },
    rulerHMove() {
      const [x, y] = this.layout.move
      const by = x * this.cos + y * this.sin
      return by - 15 - this.nowCentX
    },
    rulerVMove() {
      const [x, y] = this.layout.move
      const by = y * this.cos - x * this.sin
      return by - 15 - this.nowCentY
    }
  },
  mounted() {
    this.loadImg()
  },
  methods: {
    go(id) {
      if (id && id > -1) {
        this.actived = -1
        this.$emit('go', id)
      }
    },
    loadImg() {
      const img = new Image()
      img.src = this.src
      img.onload = () => {
        this.drawImage(img)
        this.onLoad({ target: img })
      }
    },
    drawImage(img) {
      const canvas = this.$refs.img
      const ctx = canvas.getContext('2d')
      canvas.width = img.width * this.layout.scale
      canvas.height = img.height * this.layout.scale
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      this.getSupport()
    },
    getSupport() {
      this.support =
        'onwheel' in document.createElement('div')
          ? 'wheel'
          : document.onmousewheel !== undefined
          ? 'mousewheel'
          : 'DOMMouseScroll'

      this.$refs.img.addEventListener(this.support, this.zoomPic, {
        passive: false
      })

      window.addEventListener('keydown', this.initDraw)

      // 按 Esc 键退出
      window.addEventListener('keyup', this.keyListener)
    },
    keyListener(evt) {
      switch (evt.keyCode) {
        case 27:
          this.close() // 按键 ESC
          break
        case 37: // 按键 <-
          this.go(this.next)
          break
        case 39: // 按键 ->
          this.go(this.prev)
          break
        case 16:
          // this.drawing = false
          break
        case 18:
          // this.drawingLine = !this.drawingLine
          break
      }
    },
    initDraw(evt) {
      switch (evt.keyCode) {
        case 16:
          this.drawing = !this.drawing
          break
        case 18:
          // this.drawingLine = !this.drawingLine
          break
      }
    },
    update(obj) {
      this.layout = { ...this.layout, ...obj }
    },
    close() {
      this.visible = false
      setTimeout(() => {
        if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el)
      }, 200)
      window.removeEventListener(this.support, this.zoomPic)
      window.removeEventListener('keyup', this.keyListener)
      this.$nextTick(function() {
        if (typeof this.onClose === 'function') {
          this.onClose()
        }
      })
    },
    onLoad(evt) {
      const img = evt.target
      const width = img.naturalWidth
      const height = img.naturalHeight
      const ow = this.$refs.wrap.offsetWidth - CTRL_SPACE
      const oh = this.$refs.wrap.offsetHeight - CTRL_SPACE

      let iw = width
      let ih = height

      // 扫描仪
      if (height > width) {
        this.rotate = 90
        iw = height
        ih = width
      }

      const mw = Math.floor((ow / iw) * 10000) / 10000
      const mh = Math.floor((oh / ih) * 10000) / 10000
      this.initScale = Math.min(mw, mh)
      this.cw = iw * this.initScale + CTRL_SPACE
      this.ch = ih * this.initScale + CTRL_SPACE
      this.iw = iw
      this.ih = ih
      this.setBoundary(this.initScale)

      let change = this.autoMove()
      this.update({ ...change, scale: this.initScale })
      this.$nextTick(() => {
        this.loading = false
        this.$emit('on-load', evt)
      })
    },
    setBoundary(s) {
      const scale = s || this.layout.scale
      const rotPi = (this.rotate / 180) * Math.PI
      const sin = Math.sin(rotPi)
      const cos = Math.cos(rotPi)
      const x = Math.floor((this.cw - this.iw * scale) / 2)
      const y = Math.floor((this.ch - this.ih * scale) / 2)
      const bx = x * cos + y * sin
      const by = x * sin + y * cos

      this.boundary = [
        [-bx + CTRL_SPACE, bx],
        [-by + cos * CTRL_SPACE, by - sin * CTRL_SPACE]
      ]
    },
    checkBoundary(left, top) {
      const [bx, by] = this.boundary
      return [
        Math.min(bx[0], Math.max(bx[1], left)),
        Math.min(by[0], Math.max(by[1], top))
      ]
    },
    zoomPic(e) {
      e.preventDefault()
      let change = e.deltaY || e.wheelDelta

      // FireFox
      change = navigator.userAgent.indexOf('Firefox') > 0 ? change * 30 : change

      // 修复ie的滚动缩放
      if (this.isIE) {
        change = -change
      }

      // num > 0: 缩小，num < 0: 放大
      const num = (COE * change) / 1024
      let scale = +(this.layout.scale - num).toFixed(2)

      if (scale > this.maxZoom) scale = this.maxZoom
      if (scale < this.initScale) scale = this.initScale

      const px = e.offsetX
      const py = e.offsetY
      this.zoom(scale, px, py)
    },
    zoom(scale, px = 0, py = 0) {
      this.setBoundary(scale)
      let change = {}

      if (scale === this.initScale) {
        change = this.autoMove()
      } else {
        const [x, y] = this.layout.move
        const { clientHeight: h, clientWidth: w } = this.$refs.test
        const ox = w / 2 - px
        const oy = h / 2 - py

        const left = ox * scale - ox * this.layout.scale + x
        const top = oy * scale - oy * this.layout.scale + y
        const [x1, y1] = this.checkBoundary(left, top)

        change = this.autoMove(x1, y1)
      }
      this.update({ ...change, scale })
    },
    dbZoom(e) {
      const scale =
        this.layout.scale === this.maxZoom ? this.initScale : this.maxZoom
      const px = e.offsetX
      const py = e.offsetY
      this.zoom(scale, px, py)
    },
    autoMove(x, y) {
      x = typeof x === 'undefined' ? this.boundary[0][0] : x
      y = typeof y === 'undefined' ? this.boundary[1][0] : y
      return { move: [x, y], prevMove: [x, y] }
    },
    startMove(e) {
      if (e.button !== 0) return
      e.preventDefault()

      // 开始移动
      this.downPoint = [
        e.clientX ? e.clientX : e.touches[0].clientX,
        e.clientY ? e.clientY : e.touches[0].clientY
      ]

      if (this.drawing || this.drawingLine) {
        const el = this.$refs.wrap2
        this.rect = [
          this.downPoint[0] - el.offsetLeft,
          this.downPoint[1] - el.offsetTop,
          0,
          0
        ]
        window.addEventListener('mousemove', this.drawRect)
        window.addEventListener('mouseup', this.drawEnd)
      } else {
        window.addEventListener('mousemove', this.moveImg)
        window.addEventListener('mouseup', this.moveEnd)
      }
    },
    moveImg(e) {
      e.preventDefault()
      const [prevX, prevY] = this.layout.prevMove
      const nowX = Math.max(0, e.clientX)
      const nowY = Math.max(0, e.clientY)

      const dx = nowX - this.downPoint[0]
      const dy = nowY - this.downPoint[1]
      const left =
        Math.floor((this.cos * dx - this.sin * dy) * 100) / 100 + prevX
      const top =
        Math.floor((this.cos * dy + this.sin * dx) * 100) / 100 + prevY
      const [x, y] = this.checkBoundary(left, top)

      this.update({ move: [x, y] })
    },
    moveEnd() {
      this.update({ prevMove: this.layout.move.slice() })
      window.removeEventListener('mousemove', this.moveImg)
      window.removeEventListener('mouseup', this.leaveImg)
    },
    setDrawing() {
      this.drawing = !this.drawing
    },
    setDrawingLine() {
      this.drawingLine = !this.drawingLine
    },
    drawRect(evt) {
      evt.preventDefault()
      const nowX = Math.max(0, evt.clientX)
      const nowY = Math.max(0, evt.clientY)
      let dx = nowX - this.downPoint[0]
      let dy = nowY - this.downPoint[1]
      let x = this.downPoint[0] - this.$refs.wrap2.offsetLeft
      let y = this.downPoint[1] - this.$refs.wrap2.offsetTop

      if (dx < 0) {
        x = this.downPoint[0] - this.$refs.wrap2.offsetLeft + dx
      }
      if (dy < 0) {
        y = nowY - this.$refs.wrap2.offsetTop
      }
      this.rect = [x, y, dx, dy]
    },
    drawEnd() {
      // this.rect = [0, 0, 0, 0]
      window.removeEventListener('mousemove', this.drawRect)
      window.removeEventListener('mouseup', this.drawEnd)
    },
    // 像素 - 毫米
    px2mm(ol, l, mm) {
      return Math.abs(Math.round((l / ol) * mm * 100) / 100)
    },
    insectStyle(item, iw, ih) {
      const width = Math.max(item.tailPositionX - item.headPositionX, 0.005)
      const height = Math.max(item.tailPositionY - item.headPositionY, 0.005)
      const x = item.headPositionX * iw
      const y = item.headPositionY * ih
      return {
        width: `${width * 100}%`,
        height: `${height * 100}%`,
        transform: `translate(${x}px, ${y}px)`
      }
    },
    switchRecognize() {
      this.showInsects = !this.showInsects
    },
    focus(i) {
      const {
        headPositionX: hx,
        headPositionY: hy,
        tailPositionX: tx,
        tailPositionY: ty
      } = this.insects[i]
      // let cy = (ty - hy) / 2 + hy
      // let cx = (tx - hx) / 2 + hx

      this.setBoundary(this.maxZoom)
      let px = 0
      let py = 0

      if (this.rotate === 0) {
        px = (this.iw / 2 - ((tx - hx) / 2 + hx) * this.iw) * this.maxZoom
        py = (this.ih / 2 - ((ty - hy) / 2 + hy) * this.ih) * this.maxZoom
      } else {
        py = (this.iw / 2 - ((ty - hy) / 2 + hy) * this.iw) * this.maxZoom
        px = (this.ih / 2 - ((tx - hx) / 2 + hx) * this.ih) * this.maxZoom
      }

      this.actived = i
      let change = this.autoMove(px, py)
      this.update({ ...change, scale: this.maxZoom })
    },
    download() {
      let link = document.createElement('a')
      link.setAttribute('download', path.basename(this.src))
      link.href = this.src
      link.click()
    },
    downloadCanvas() {
      downloadLamp(this.src, this.insects)
    }
  }
}
</script>

<style lang="scss">
$head-height: 60px;

.insect-mng {
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 204;
  /* max-height: calc(100vh - 60px); */
  background-color: rgba(10, 10, 10, 0.7);
  .modal-button {
    z-index: 3;
    position: absolute;
    width: 4rem;
    height: 4rem;
    font-size: 2rem;
    color: #fff;
    background-color: transparent;
    border-width: 2px;
    &.prev {
      left: 2%;
      top: 50%;
    }
    &.next {
      right: 2%;
      top: 50%;
    }
  }

  .insect-mng-head {
    display: flex;
    justify-content: space-between;
    height: 60px;
    padding: 0 40px;
    background-color: rgb(10, 10, 10);
    .insect-mng-title,
    .insect-mng-subtitle,
    .insect-mng-control {
      flex: 1;
      font-size: 1.5rem;
      color: #fff;
      line-height: $head-height;
    }
    .insect-mng-control {
      color: #fff;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      i {
        cursor: pointer;
        line-height: $head-height;
        font-size: 1.5rem;
        &:not(:first-child) {
          margin-left: 1rem;
        }
      }
      .el-button-group i {
        line-height: 16px !important;
      }
    }
    .insect-mng-title {
      text-align: center;
    }
  }
  .insect-mng-content {
    overflow: hidden;
    width: 100%;
    height: calc(100vh - 60px);
    display: flex;
    justify-content: center;
    align-items: center;
    // position: relative;
    img {
      width: auto !important;
    }
    .insect-mng-container {
      z-index: 2;
      position: relative;
      user-select: none;
    }
    .tools {
      position: absolute;
      top: $head-height;
      width: 66px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      .el-button {
        margin-left: 6px;
      }
      .el-button + .el-button {
        // margin-left: 0;
        margin-top: 9px;
      }
      .el-button.actived {
        color: #fff;
        background-color: #e6a23c;
      }
    }
    .insects-tb {
      background: gray;
      position: absolute;
      // right: 0;
      top: $head-height;
      user-select: none;
      width: 140px;
      // height: 100px;
      overflow: auto;
      // border-top: 1px solid #909399;
      // border-bottom: 1px solid #909399;
      color: #000;
      .el-button:focus {
        color: red;
        background: #67c23a;
      }
      .el-button:hover {
        background: #67c23a;
      }
    }
    .insects-tb-row {
      cursor: pointer;
      padding: 8px;
      padding-left: 2rem;
      color: #f1f1f1;
      font-size: 14px;
      border-bottom: 1px solid #909399;
    }
    .insects-tb-row.actived {
      color: red;
      background-color: #e4e7ed;
    }
    .insects-tb-row__num {
      text-align: right;
      font-size: 12px;
      color: #000;
      position: absolute;
      left: 4px;
    }
  }
  .wrap2 {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 1);
    &::before {
      content: ' ';
      width: 30px;
      height: 30px;
      position: absolute;
      left: 0;
      top: 0;
      background-color: #000;
      z-index: 204;
    }
    &.drawing {
      cursor: crosshair;
    }
    .scale-rect,
    .scale-line {
      border: 2px solid red;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 104;
      box-sizing: border-box;
      pointer-events: none;
    }
    .scale-line {
      border: none;
      height: 2px;
      background-color: red;
      transform-origin: left top;
    }
    .rect-size {
      position: absolute;
      top: -1.5rem;
      width: 200px;
      color: #fff;
      text-shadow: 1px 1px 8px #000;
    }
    .line-size {
      position: absolute;
      top: -1.5rem;
      left: 0;
      width: 100%;
      color: #fff;
      text-shadow: 1px 1px 8px #000;
      text-align: center;
    }
    .insects-rect {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      user-select: none;
      pointer-events: none;
    }
    .model-insect {
      position: absolute;
      // border: 2px solid rgb(64, 158, 255);
      border: 2px solid rgb(64, 158, 255);
    }
    .model-insect.actived {
      border: 2px solid red;
    }
    .model-insect__name {
      position: absolute;
      top: -28px;
      left: 4px;
      color: #fff;
      text-align: left;
      text-shadow: 1px 1px 8px #000;
    }
    .model-insect__name.rotate {
      transform: rotate(-90deg);
      top: calc(100% - 28px);
      left: -2rem;
    }
  }

  .ruler {
    background-color: #dcdfe6;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 204;
  }
}
</style>
